import service from '~api/backstage';
import * as types from '../types';

export default {
  // 获取侧边栏菜单树
  getMenuTree({ commit }, payload) {
    return service.apiGetAsideTree(payload).then((res) => {
      if (res.data) {
        commit(types.GET_MENU_TREE_LIST, res.data.data);
      }
    });
  },
  getUserList({ commit }, payload) {
    return service.apiGetUserList(payload).then((res) => {
      if (res.data) {
        commit(types.GET_CRM_USERS, res.data);
      }
    });
  },
  deleteUser({ commit }, payload) {
    return service.apiDeleteUser(payload);
  },
  addTeamMember({ commit }, payload) {
    return service.apiAddTeamMember(payload);
  },
  addTeam({ commit }, payload) {
    return service.apiAddTeam(payload);
  },
  // 获取团队列表
  getTeamList({ commit }, payload) {
    return service.apiGetTeamList(payload).then((res) => {
      if (res.data) {
        commit(types.GET_TEAM_LIST, res.data);
      }
    });
  },
  getParentTeamList({ commit }, payload) {
    return service.apiGetParentTeamList(payload).then((res) => {
      if (res.data) {
        commit(types.GET_PARENT_TEAM_LIST, res.data);
      }
    });
  },
  getTeamMembers({ commit }, payload) {
    return service.apiGetTeamMembers(payload).then((res) => {
      if (res.data) {
        commit(types.GET_TEAM_MEMBERS, res.data);
      }
    });
  },
  deleteTeamMember({ commit }, payload) {
    return service.apiDeleteTeamMember(payload);
  },
  deleteTeam({ commit }, payload) {
    return service.apiDeleteTeam(payload);
  },
  updateTeam({ commit }, payload) {
    return service.apiUpdateTeam(payload);
  },
  addUser({ commit }, payload) {
    return service.apiAddUser(payload);
  },
  /**
   * 获取操作日志列表
   */
  getRecords({ commit }, payload) {
    return service.apiGetRecords(payload).then((res) => {
      if (res.data) {
        commit(types.GET_RECORDS, res.data);
      }
    });
  },
  /**
   * 获取字典列表
   */
  getDictionaryList({ commit }, payload) {
    return service.apiGetDictionaryList(payload).then((res) => {
      if (res.data) {
        commit(types.GET_DICTIONARY_LIST, res.data);
      }
    });
  },
  deleteDictionary({ commit }, payload) {
    return service.apiDeleteDictionary(payload);
  },
  addDictionary({ commit }, payload) {
    return service.apiAddDictionary(payload);
  },
  updateDictionary({ commit }, payload) {
    return service.apiUpdateDictionary(payload);
  },
  getDictionaryDetail({ commit }, payload) {
    return service.apiGetDictionaryDetail(payload).then((res) => {
      if (res.data) {
        commit(types.GET_DICTIONARY_DETAIL, res.data);
      }
    });
  },
  /**
   * 获取字典項列表
   */
  getDictionaryDetailList({ commit }, payload) {
    return service.apiGetDictionaryDetailList(payload).then((res) => {
      if (res.data) {
        commit(types.GET_DICTIONARY_DETAIL_LIST, res.data);
      }
    });
  },
  deleteDictionaryDetail({ commit }, payload) {
    return service.apiDeleteDictionaryDetail(payload);
  },
  updateDictionaryDetail({ commit }, payload) {
    return service.apiUpdateDictionaryDetail(payload);
  },
  addDictionaryDetail({ commit }, payload) {
    return service.apiAddDictionaryDetail(payload);
  },
  sortSave({ commit }, payload) {
    return service.apiSortSave(payload);
  },
  /**
   * 团队字典配置
   */
  getTeamConfigList({ commit }, payload) {
    return service.apiGetTeamConfigList(payload).then((res) => {
      if (res.data) {
        commit(types.GET_TEAM_CONFIG_LIST, res.data);
      }
    });
  },
  getSecondTeamList({ commit }, payload) {
    return service.apiGetSecondTeamList(payload).then((res) => {
      if (res.data) {
        commit(types.GET_SECOND_TEAM_LIST, res.data);
      }
    });
  },
  getAllCategoryList({ commit }, payload) {
    return service.apiGetAllCategoryList(payload).then((res) => {
      if (res.data) {
        commit(types.GET_ALL_CATEGORY_LIST, res.data);
      }
    });
  },
  getAllDictionaryList({ commit }, payload) {
    return service.apiGetAllDictionaryList(payload).then((res) => {
      if (res.data) {
        commit(types.GET_ALL_DICTIONARY_LIST, res.data);
      }
    });
  },
  saveAddTeamConfig({ commit }, payload) {
    return service.apiSaveAddTeamConfig(payload);
  },
  getTeamConfigDetail({ commit }, payload) {
    return service.apiGetTeamConfigDetail(payload).then((res) => {
      if (res.data) {
        commit(types.GET_TEAM_CONFIG_DETAIL, res.data);
      }
    });
  },
  saveUpdateTeamConfig({ commit }, payload) {
    return service.apiSaveUpdateTeamConfig(payload);
  },
  deleteTeamConfig({ commit }, payload) {
    return service.apiDeleteTeamConfig(payload);
  },
  // 团队成员标签修改
  memberLabelChange({ commit }, payload) {
    return service.apiMemberLabelChange(payload);
  },
  // 更换团队
  handleTeamChange({ commit }, payload) {
    return service.apiTeamChange(payload).then((res) => {
      const data = res.data;
      const loop = (item) => {
        item.forEach((v) => {
          if (v.children.length === 0) {
            delete v.children;
          } else {
            loop(v.children);
          }
        });
      };

      loop(data.children);

      const arr = {
        depth: data.depth,
        label: data.label,
        leaderUserId: data.leaderUserId,
        leaderUserName: data.leaderUserName,
        teamType: data.teamType,
        value: data.value,
        children: data.children,
      };

      if (res.data) {
        commit(types.GET_TEAM_CHANGE, [arr]);
      }
    });
  },
  getRoleList({ commit }, payload) {
    return service.apiGetRoleList(payload).then((res) => {
      if (res.data) {
        if (res.data) {
          commit(types.GET_ROLE_LIST, res.data);
        }
      }
    });
  },
  getRoleUserList({ commit }, payload) {
    return service.apiGetRoleUserList(payload).then((res) => {
      if (res.data) {
        if (res.data) {
          commit(types.GET_ROLE_USER_LIST, res.data);
        }
      }
    });
  },
  // 回款导入
  upload({ commit }, payload) {
    return service.apiImportUserList(payload.params, payload.config);
  },
  // 产品线管理
  getProductList({ commit }, payload) {
    return service.queryProductList(payload).then((res) => {
      if (res.data) {
        commit(types.GET_PRODUCT_LIST, res.data);
      }
    });
  },
};
